export const getFilter = (state) => state.contacts.filter;
